// ─────────────────────────────────────────────────────────────────────────────
// Divider.jsx
// Decorative amber accent line — used between sections or inside cards.
//
//   <Divider />                          // default: left-aligned, 40px wide
//   <Divider align="center" width="60px" />
//   <Divider color="green" width="100%" />
//   <Divider thickness="3px" />
// ─────────────────────────────────────────────────────────────────────────────

export default function Divider({
  align     = 'left',        // 'left' | 'center' | 'right'
  width     = '40px',
  thickness = '3px',
  color     = 'amber',       // 'amber' | 'green' | 'white' | 'muted'
  margin    = '0 0 20px',
  style: extraStyle = {},
}) {
  const colors = {
    amber: '#ed9716',
    green: '#007935',
    white: 'rgba(255,255,255,0.6)',
    muted: 'rgba(0,0,0,0.12)',
  }

  const marginAuto = align === 'center'
    ? `${margin.split(' ')[0] ?? '0'} auto`
    : align === 'right'
      ? `${margin} 0 0 auto`
      : margin

  return (
    <div
      style={{
        width,
        height:      thickness,
        background:  colors[color] || color,
        margin:      marginAuto,
        flexShrink:  0,
        ...extraStyle,
      }}
    />
  )
}